<template>
	<component :is="layout" :key="routerViewKey" :class="layoutClass">
		<!--		<transition name="slide-next" mode="out-in">-->
		<!--			<router-view :key="routerViewKey"/>-->
		<!--		</transition>-->
		<slot v-if="layout === 'Loading'"/>
		<router-view v-else/>
	</component>
</template>
<script>
import {mapState} from "vuex";
import Error from "../../layouts/Error";
import Auth from "./layouts/Auth";
import Loading from "./layouts/Loading";
import Portal from "./layouts/Portal";

const defaultLayout = "Portal";

export default {
	components: {
		Auth,
		Error,
		Portal,
		Loading,
	},

	data() {
		return {
			routerViewKey: 0,
			datepickerParams: {},
		};
	},

	computed: {
		...mapState("errorsStore", [
			"error",
		]),
		layout() {
			if (this.error) {
				return "Error";
			}

			if (this.$route.meta.layout) {
				return this.$route.meta.layout;
			}

			return !this.$authed() ? "Loading" : defaultLayout;
		},
		layoutClass() {
			return "app--portal--" + this.layout.toLowerCase();
		},
	},

	methods: {
		refresh() {
			this.routerViewKey += 1;
		},
	},
};
</script>
